// TODO: change conditions when parser will be ready
import { jobStatusNames } from '../../common/constants/jobStatusNames';

export const CONDITIONS = {
    IS_DONE: record => record?.status?.name === jobStatusNames.Done && record?.files?.length !== 0,

    IN_PROGRESS: record =>
        record?.status?.name !== jobStatusNames.Done && record?.status?.name !== jobStatusNames.Rejected,

    IS_INSTANT_REPORT: record => record?.type === 'internal' || record?.type === 'combined',

    HAS_FILES: record =>
        record?.status?.name !== jobStatusNames.Done &&
        record?.status?.name !== jobStatusNames.Rejected &&
        record?.files?.length > 0,

    REJECTED: record => record?.status?.name === jobStatusNames.Rejected,
};

/**
 * The orders list's "view report" button, decided once for both the mobile (icon) and desktop (label) layouts.
 * `tone` is 'viewable' (report can be opened), 'rejected', or 'pending' (dealer report not there yet).
 */
export const getViewButtonState = record => {
    const isViewable = CONDITIONS.IS_INSTANT_REPORT(record) || CONDITIONS.IS_DONE(record);
    const isRejected = !isViewable && CONDITIONS.REJECTED(record);

    let tone = 'pending';
    let labelKey = 'profile:button.in-progress';

    if (isViewable) {
        tone = 'viewable';
        labelKey = 'profile:button.view-report';
    } else if (isRejected) {
        tone = 'rejected';
        labelKey = 'jobs:statuses.rejected';
    }

    return {
        tone,
        labelKey,
        disabled: !isViewable,
        // an instant report is viewable while the dealer part is still in progress: no spinner on it
        showSpinner: CONDITIONS.IN_PROGRESS(record) && !CONDITIONS.IS_INSTANT_REPORT(record),
    };
};
